@if (formGroup) {
  <div class="form-row" [formGroup]="formGroup">
    <div class="form-group col-md-3">
      <label>{{ 'content.type' | translate }}
        <app-required [control]="control"></app-required>
        <select class="form-select" formControlName="type" #typeInput>
          <option value=""></option>
          @for (type of hawkTypes | keyvalue; track type) {
            <option value="{{ type.key }}">{{ type.value }}</option>
          }
        </select>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="control.errors" [element]="typeInput"></app-validation-errors>
    </div>
  </div>
}
